import { BrowserDeployment, BrowserLastUsage } from '@/client'
import { db } from '../database'

export interface BrowserLastUsageTable {
  _id: string // Unique identifier, possibly a UUID
  created: string // ISO 8601 formatted date-time string
  updated: string // ISO 8601 formatted date-time string
  deleted: number // Boolean stored as integer (0 or 1)
  deleted_at: string | null // Nullable ISO 8601 date-time string
  software_name: string
  deployment_id: string
  installation_id: string
  timestamp: string
  email: string | null
  deployment_name?: string // Optional due to join function
}

export interface BrowserDeploymentTable {
  _id: string // Unique identifier, possibly a UUID
  created: string // ISO 8601 formatted date-time string
  updated: string // ISO 8601 formatted date-time string
  deleted: number // Boolean stored as integer (0 or 1)
  deleted_at: string | null // Nullable ISO 8601 date-time string
  name: string
  description: string
  activity_processed_information: string // JSON string representing BrowserDeploymentActivityProcessedInformation
}

export async function createBrowserLastUsageTable() {
  await db.schema
    .createTable('browser_last_usage')
    .ifNotExists()
    .addColumn('_id', 'text', (col) => col.primaryKey().notNull())
    .addColumn('created', 'text', (col) => col.notNull()) // ISO 8601 string
    .addColumn('updated', 'text', (col) => col.notNull()) // ISO 8601 string
    .addColumn('deleted', 'integer', (col) => col.notNull()) // Boolean as integer
    .addColumn('deleted_at', 'text') // Nullable ISO 8601 string
    .addColumn('software_name', 'text')
    .addColumn('deployment_id', 'text')
    .addColumn('installation_id', 'text')
    .addColumn('timestamp', 'text')
    .addColumn('email', 'text')
    .execute()

  // Index auf der Spalte 'software_name' erstellen
  await db.schema
    .createIndex('idx_browser_last_usage')
    .ifNotExists()
    .on('browser_last_usage')
    .column('software_name')
    .execute()
}

export async function createBrowserDeploymentTable() {
  await db.schema
    .createTable('browser_deployment')
    .ifNotExists()
    .addColumn('_id', 'text', (col) => col.primaryKey().notNull())
    .addColumn('created', 'text', (col) => col.notNull()) // ISO 8601 string
    .addColumn('updated', 'text', (col) => col.notNull()) // ISO 8601 string
    .addColumn('deleted', 'integer', (col) => col.notNull()) // Boolean as integer
    .addColumn('deleted_at', 'text') // Nullable ISO 8601 string
    .addColumn('name', 'text')
    .addColumn('description', 'text')
    .addColumn('activity_processed_information', 'text')
    .execute()

  // Index auf der Spalte 'name' erstellen
  await db.schema
    .createIndex('idx_browser_deployment')
    .ifNotExists()
    .on('browser_deployment')
    .column('name')
    .execute()
}

export function serializeBrowserLastUsage(lastUsage: BrowserLastUsage) {
  return {
    ...lastUsage,
    deleted: lastUsage.deleted ? 1 : 0,
  }
}

export function deserializeBrowserLastUsage(
  record: BrowserLastUsageTable
): BrowserLastUsage {
  return {
    ...record,
    deleted: Boolean(record.deleted),
  }
}

export function serializeBrowserDeployment(deployment: BrowserDeployment) {
  return {
    ...deployment,
    deleted: deployment.deleted ? 1 : 0,
    activity_processed_information: JSON.stringify(
      deployment.activity_processed_information
    ),
  }
}

export function deserializeBrowserDeployment(
  record: BrowserDeploymentTable
): BrowserDeployment {
  return {
    ...record,
    deleted: Boolean(record.deleted),
    activity_processed_information: JSON.parse(
      record.activity_processed_information
    ),
  }
}
